import { render, staticRenderFns } from "./DatasetDetail.vue?vue&type=template&id=53775548&scoped=true&"
import script from "./DatasetDetail.vue?vue&type=script&lang=ts&"
export * from "./DatasetDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53775548",
  null
  
)

export default component.exports